import type { QuoteStatus } from '@/api/types';

export const ALL_STATUSES: QuoteStatus[] = [
  'draft',
  'sent',
  'accepted',
  'rejected',
  'invoiced',
  'paid',
];

export const STATUS_TRANSITIONS: Record<QuoteStatus, QuoteStatus[]> = {
  draft: ALL_STATUSES.filter((s) => s !== 'draft'),
  sent: ALL_STATUSES.filter((s) => s !== 'sent'),
  accepted: ALL_STATUSES.filter((s) => s !== 'accepted'),
  rejected: ALL_STATUSES.filter((s) => s !== 'rejected'),
  invoiced: ALL_STATUSES.filter((s) => s !== 'invoiced'),
  paid: ALL_STATUSES.filter((s) => s !== 'paid'),
};

// Stage levels for "backward" detection. Rejected is same level as sent
// (it's a branch, not earlier). Moving to a lower stage = backward.
export const STATUS_STAGE: Record<QuoteStatus, number> = {
  draft: 0,
  sent: 1,
  rejected: 1,
  accepted: 2,
  invoiced: 3,
  paid: 4,
};

export function statusBadgeProps(status: QuoteStatus): {
  variant?: 'secondary' | 'destructive';
  className?: string;
} {
  switch (status) {
    case 'draft':
      return { variant: 'secondary' };
    case 'sent':
      return {
        className: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
      };
    case 'accepted':
      return {
        className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
      };
    case 'rejected':
      return { variant: 'destructive' };
    case 'invoiced':
      return {
        className: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
      };
    case 'paid':
      return {
        className: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300',
      };
  }
}
